import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";
import StorageContainerWrapper from "@components/layouts/storagecontainerpricesWrapper";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function StorageContainerPricesHome(): ReactElement {
    return (
        <StorageContainerWrapper>
            <TermsAndConditions
                domain="storagecontainerprices.com"
                category="Storage Containers"
            />
        </StorageContainerWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
